export default import.meta.ROLLUP_FILE_URL_J0EqTGXjQxN38NKqeggYiw